import { render, staticRenderFns } from "./DownloadBanner.vue?vue&type=template&id=a4bcc8c4"
import script from "./DownloadBanner.vue?vue&type=script&lang=js"
export * from "./DownloadBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports